import { render, staticRenderFns } from "./SwapFreeGroup.vue?vue&type=template&id=fc28cc8c"
import script from "./SwapFreeGroup.vue?vue&type=script&lang=js"
export * from "./SwapFreeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports